export default __webpack_public_path__ + "static/media/arrow-down.93088431.svg";